import { CurrentUser } from "models/auth/CurrentUser";

export enum CurrentUserAction {
	LOGIN = "login",
	UPDATE = "update",
	LOGOUT = "logout"
}

type CurrentUserReducerAction = {
	type: CurrentUserAction;
	user?: CurrentUser | null;
};

export default function currentUserReducer(
	user: CurrentUser | null | undefined,
	action: CurrentUserReducerAction
): CurrentUser | null | undefined {
	switch (action.type) {
		case CurrentUserAction.LOGIN: {
			return action.user || null;
		}
		case CurrentUserAction.UPDATE: {
			if (action.user) {
				return action.user;
			}
			return user;
		}
		case CurrentUserAction.LOGOUT: {
			return null;
		}
		default: {
			throw Error(`Unknown action: ${action.type}`);
		}
	}
}
